import { generateActionCreator as generate, reduxTypes as types } from '@tmosystems/core';

export const MAPS__CHANGE_VIEWPORT = generate('MAPS__CHANGE_VIEWPORT', { type: types.SYNC });
export const MAPS__CHANGE_VIEWPORT_INDEX = generate('MAPS__CHANGE_VIEWPORT_INDEX', { type: types.SYNC });
